export type HumanInputDataType = "number" | "string";
export type HumanInputComponentType = "text" | "slider" | "rating" | "choice";

interface HumanInputDataTypeConfig {
  label: string;
  component_options: HumanInputComponentType[];
}

export const HUMAN_INPUT_DATA_TYPE: Record<HumanInputDataType, HumanInputDataTypeConfig> = {
  number: {
    label: "Number",
    component_options: ["text", "slider"],
  },
  string: {
    label: "Text",
    component_options: ["text"],
  },
};

export const UI_COMPONENT_LABELS: Record<HumanInputComponentType, string> = {
  text: "Textbox",
  slider: "Slider",
  rating: "Rating",
  choice: "Choice",
};

export const DEFAULT_SLIDER_CONFIG = {
  min: 0,
  max: 10,
  step: 0.99,
};

export const DEFAULT_RATING_CONFIG = {
  max: 5,
};

export const DEFAULT_CHOICE_OPTIONS = ["Pass", "Fail"];

export const SMART_TABLE_HUMAN_INPUT_CONTROLS = [
  {
    component: "slider",
    label: "Scale",
    description: "Score with a bounded numeric range.",
  },
  {
    component: "rating",
    label: "Rating",
    description: "Pick a quick 1–5 quality rating.",
  },
  {
    component: "choice",
    label: "Choice",
    description: "Select from a small set of labels.",
  },
] satisfies {
  component: Exclude<HumanInputComponentType, "text">;
  label: string;
  description: string;
}[];

export const SAMPLE_TEXTS = {
  number: "123",
  string: "This prompt output is not amazing because it lacks specific examples.",
};
